import React, { useId, useState } from "react";

const ACCEPT = ".pdf,application/pdf";

export const isPdfResume = (file) =>
  file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");

const ResumeFileInput = ({ file, onFileChange, error }) => {
  const inputId = useId();
  const [formatError, setFormatError] = useState("");

  const handleChange = (e) => {
    const selected = e.target.files?.[0] || null;
    if (!selected) {
      setFormatError("");
      onFileChange(null);
      return;
    }
    if (!isPdfResume(selected)) {
      setFormatError("Only PDF format is allowed");
      onFileChange(null);
      e.target.value = "";
      return;
    }
    setFormatError("");
    onFileChange(selected);
  };

  const displayError = formatError || error;

  return (
    <div style={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
      <input
        id={inputId}
        type="file"
        accept={ACCEPT}
        onChange={handleChange}
        style={{ display: "none" }}
      />
      <label
        htmlFor={inputId}
        style={{
          display: "inline-block",
          padding: "6px 12px",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          fontSize: "14px",
          cursor: "pointer",
          backgroundColor: "#fff",
        }}
      >
        Choose PDF
      </label>
      {file ? (
        <div
          title={file.name}
          style={{
            marginTop: "6px",
            fontSize: "12px",
            color: "#555",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
        >
          {file.name}
        </div>
      ) : null}
      {displayError ? (
        <span style={{ color: "#d32f2f", fontSize: "12px", display: "block", marginTop: "4px" }}>
          {displayError}
        </span>
      ) : null}
    </div>
  );
};

export default ResumeFileInput;
